'use client'
import { Button } from '@/components/ui/button'
import { Suspense, useState } from 'react'
import Enter from './_components/enter'
import FastReg from './_components/fastreg'

export default function Auth() {
	const [register, setRegister] = useState(false)

	return (
		<div className='flex min-h-screen w-full items-center sm:justify-center justify-start flex-col px-4 py-6 sm:px-6 lg:px-8'>
			<div className='w-full max-w-md'>
				<Suspense>{register ? <FastReg /> : <Enter />}</Suspense>
				<div className='mt-6 text-center'>
					{register ? (
						<p className='text-white text-sm'>
							Есть аккаунт?{' '}
							<Button
								variant='link'
								className='underline text-white p-0 h-auto font-normal hover:text-blue-400 transition-colors'
								onClick={() => setRegister(false)}
							>
								Войти
							</Button>
						</p>
					) : (
						<p className='text-white text-sm'>
							Еще нет аккаунта?{' '}
							<Button
								variant='link'
								className='underline text-white p-0 h-auto font-normal hover:text-blue-400 transition-colors'
								onClick={() => setRegister(true)}
							>
								Зарегистрироваться
							</Button>
						</p>
					)}
				</div>
			</div>
		</div>
	)
}
